import axios from "axios";

// Values come from public/config.js (build/config.js after build), which can be
// edited on the server without rebuilding. Fallbacks are used if the file is missing.
const runtimeConfig = window.APP_CONFIG || {};
const baseUrl = runtimeConfig.baseUrl || "https://mobilepublic.evoca.am/api";
const publicServiceUrl =
    runtimeConfig.publicServiceUrl || "https://publicservice.evoca.am/api";
const authorizationCredential = "2047d0ff-760d-44c0-b400-0f0abae669fe";
const version = "4.30.2";


export async function getCardAppData(lang) {
    return await axios.get(`${baseUrl}/app/getcardappdata?page=1&start=0&limit=25`, {
        headers: {
            "X-Language": lang,
            "AuthorizationCredential": authorizationCredential,
            "X-Version": version
        }
    }).then(res => res.data);
}

export async function getCommunity(state, lang) {
    return await axios.get(`${baseUrl}/tree/getComm?State=${state}`, {
        headers: {
            "X-Language": lang,
            "AuthorizationCredential": authorizationCredential,
            "X-Version": version
        }
    }).then(res => res.data);
}

export async function addCard(cardApplication, lang) {
    return await axios.post(`${baseUrl}/app/card`, cardApplication, {
        headers: {
            "X-Language": lang,
            "X-Version": version,
            "AuthorizationCredential": authorizationCredential
        }
    });
}

export async function validateAccept(socialCardNumber, lang) {
    return await axios.get(`${publicServiceUrl}/PublicLoan/ValidateAccept/${socialCardNumber}`, {
        headers: {
            "X-Language": lang,
            "ServiceAuthToken": '3D28344A-3B7C-4EF6-A9F5-364B94492E82',
            "X-Version": version
        }
    }).then(res => res.data);
}
